import _ from "lodash";

const prefixMaker = function(entry) {
  if (entry.matchingStyle === 'ALL') {
    return "and ";
  } else if (entry.matchingStyle === 'ANY') {
    return "or ";
  }
};

export const triggerConditionFormatter = function(translate, entry) {
  const loopData = [];
  let prefix = "";
  _.forEach(entry.criteria, function(c) {
    loopData.push(prefix + c);
    prefix = prefixMaker(entry);
  });
  _.forEach(entry.pageViews, function(domains, time) {
    _.forEach(domains, function(domain) {
      loopData.push(prefix + domain + " times " + translate.instant('trigger.pageView.time.' + time));
      prefix = prefixMaker(entry);
    });
  });
  return loopData;
};
